import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f9f25cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-start tw-justify-between !tw-h-full !tw-w-full tw-px-4 tw-py-5 tw-box-border" }

import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterCard',
  props: {
  data: {
    type: Object,
    default: () => ({
      label: "Label",
      count: "count",
    }),
  },
  isActive: Boolean,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-rounded-lg !tw-max-h-[95px] !tw-min-h-[95px] tw-bg-white !tw-h-full !tw-w-full tw-border-2 tw-border-white tw-box-border tw-cursor-pointer", {
      'bg-color-active': __props.isActive,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Text, {
        variant: "h2",
        whiteSpace: "nowrap",
        textColor: "rgba(12, 15, 74, 0.8)"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.data.count), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, {
        variant: "h6",
        whiteSpace: "nowrap",
        textColor: "rgba(12, 15, 74, 0.8)"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.data.label), 1)
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})